import { GetSenderInfoResponseInterface } from '@vendasta/email';
import { DEFAULT_SENDER_DOMAIN } from './default';

export class SelectedDomain {
  readonly canUse: boolean;

  private static decideCanUse(domain: string, senderInfo: GetSenderInfoResponseInterface): boolean {
    if (domain === DEFAULT_SENDER_DOMAIN) {
      return true;
    }
    if (!domain) {
      return false;
    }
    if (domain === senderInfo.domain && senderInfo.isPlatformAuthorized) {
      return true;
    }
    return false;
  }

  public static fromSenderInfo(senderInfo: GetSenderInfoResponseInterface, useOwnDown): SelectedDomain {
    const domainToUse = SelectedDomain.computeSelectedDomain(senderInfo, useOwnDown);
    return new SelectedDomain(domainToUse, senderInfo);
  }

  public static of(domainToUse: string, senderInfo: GetSenderInfoResponseInterface): SelectedDomain {
    return new SelectedDomain(domainToUse, senderInfo);
  }

  public static default(): SelectedDomain {
    return new SelectedDomain(DEFAULT_SENDER_DOMAIN, {});
  }

  private static computeSelectedDomain(senderInfo: GetSenderInfoResponseInterface, useOwnDomain: boolean): string {
    if (!useOwnDomain) {
      return DEFAULT_SENDER_DOMAIN;
    }
    if (senderInfo.domain === DEFAULT_SENDER_DOMAIN) {
      return undefined;
    }
    return senderInfo.domain;
  }

  private constructor(public readonly domain: string, senderInfo: GetSenderInfoResponseInterface) {
    this.canUse = SelectedDomain.decideCanUse(domain, senderInfo);
  }
}
